import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import "react-toastify/dist/ReactToastify.css";
import RouterFile from "./Routes";
import WebsiteTitle from "./helpers/WebsiteTitle";
import { getServToken } from "./services";
import "./App.css";
import IDModal from "./modules/Modals/IDModal";
import { getHasNationalID } from "./network";
// import PostPay from "./modules/Paymob/PostPay";
// import "./firebase";
// import Notifications from "./modules/Notification/Notifications";

function App() {
  const [open, setOpen] = useState(false);
  const { authorization } = useSelector((state) => state.auth);
  const { lang, dir } = useSelector((state) => state.language);
  const { i18n } = useTranslation();
  getServToken(authorization?.token);

  useEffect(() => {
    if (authorization?.token) {
      getHasNationalID(
        (res) => {
          setOpen(res?.data);
        },
        () => {}
      );
    }
  }, [authorization?.token]);

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, []);

  return (
    <div className="App" lang={lang}>
      <Helmet>
        <html lang={lang} dir={dir}></html>
      </Helmet>
      <ToastContainer />
      <WebsiteTitle />
      {/* <Notifications /> */}
      <RouterFile />
      <IDModal open={open} setOpen={setOpen} />
      {/* <PostPay /> */}
    </div>
  );
}

export default App;
